import React, { useCallback, useEffect, useState } from 'react';
import { DropHeader, InputArea } from './styles';
interface Props {
  onChangeSearch?: (value: string) => void;
  applyPaddingTop?: boolean;
}
function DropdownSearch({ onChangeSearch, applyPaddingTop = false }: Props) {
  const [searchQuery, setSearchQuery] = useState('');

  // On search change
  const onUpdateSearch = useCallback(
    (value: string) => {
      setSearchQuery(value);
      onChangeSearch?.(value);
    },
    [onChangeSearch]
  );

  useEffect(() => {
    return () => {
      onChangeSearch?.('');
    };
  }, [onChangeSearch]);

  return (
    <DropHeader className='search-div' onClick={(e) => e.stopPropagation()} applyPaddingTop={applyPaddingTop}>
      <InputArea
        type='text'
        placeholder='Search'
        autoFocus
        value={searchQuery}
        onChange={(e) => onUpdateSearch(e.target.value)}
      />
    </DropHeader>
  );
}

export default DropdownSearch;
